import { render, staticRenderFns } from "./InvestorPurchaseOrders.vue?vue&type=template&id=3edd244a&"
import script from "./InvestorPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./InvestorPurchaseOrders.vue?vue&type=script&lang=js&"
import style0 from "./InvestorPurchaseOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports